import { render, staticRenderFns } from "./ChatQuickAnswer.vue?vue&type=template&id=1f4ac6e8&"
import script from "./ChatQuickAnswer.vue?vue&type=script&lang=js&"
export * from "./ChatQuickAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ChatQuickAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports